import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// VOR-145: `cn` idêntico ao do Vórtex DS (`twMerge(clsx(...))`) — resolve
// utilities Tailwind conflitantes (a última vence). Implementado localmente
// com as mesmas libs que o DS pina (clsx ^2.1.1 + tailwind-merge ^3.6.0) em
// vez de re-exportar de `@vorseum/vortex/react`: aquele índice é marcado
// `"use client"`, o que tornaria o `cn` uma função-cliente e quebraria as
// chamadas em Server Components (ex.: app/studio, app/freela renderizam no
// servidor). A implementação é trivial e fica server-safe aqui.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
